/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PresignIn {
  /** @exclusiveMinimum 0 */
  bytes: number;
  content_type: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  filename: string;
}
